// src/components/withThor.tsx
import React2, { useEffect } from "react";

// src/GTMLoad.ts
function GTMLoad_default(_window, doc, balise, layer, id, cloudfront, customeProxy, direct = false) {
  _window[layer] = _window[layer] || [];
  _window[layer].push({ "gtm.start": (/* @__PURE__ */ new Date()).getTime(), event: "gtm.js" });
  const f = doc.getElementsByTagName(balise)[0], j = doc.createElement(balise), dl = layer != "dataLayer" ? "&l=" + layer : "";
  j.async = true;
  const localSRC = cloudfront ? doc.location.origin + "/gtmlocal" : "https://gtmaws-prod.seloger.com/gtmlocal";
  const directSRC = "https://www.googletagmanager.com/gtm.js?id=" + id + dl;
  const src = document.cookie.indexOf("tmsdebug") === -1 ? !!customeProxy ? customeProxy : localSRC : directSRC;
  j.src = direct ? directSRC : src;
  f.parentNode.insertBefore(j, f);
}

// src/context/provider.tsx
import React, { createContext, useContext, useReducer } from "react";

// src/context/reducer.ts
var reducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_DEV_MODE":
      return {
        ...state,
        devMode: action.payload
      };
      break;
    case "UPDATE_MEDIUM":
      return {
        ...state,
        medium: {
          ...state.medium,
          [action.payload.key]: action.payload.value
        }
      };
      break;
    case "UPDATE_SAVED_INFO":
      if (typeof action.payload.key !== "string" || !!!action.payload.key || typeof action.payload.value !== "string" || !!!action.payload.value)
        return state;
      return {
        ...state,
        flags: {
          ...state.flags,
          savedInfos: {
            ...state.flags.savedInfos,
            [action.payload.key]: action.payload.value
          }
        }
      };
      break;
    case "ADD_FLAGGED":
      return {
        ...state,
        flags: {
          ...state.flags,
          flagged: {
            ...state.flags.flagged,
            [action.payload]: true
          }
        }
      };
      break;
  }
};

// src/context/provider.tsx
var StateContext = createContext({});
var StateProvider = ({
  reducer: reducer2,
  initialState: initialState2,
  children
}) => /* @__PURE__ */ React.createElement(StateContext.Provider, { value: useReducer(reducer2, initialState2) }, children);
var useStateValue = () => useContext(StateContext);

// src/context/state.ts
var initialState = {
  devMode: false,
  medium: {},
  flags: {
    savedInfos: {},
    flagged: {}
  },
  compatibilities: {
    GA3: true,
    GA4: false
  }
};

// src/components/withThor.tsx
import "thor";
var WithThor = ({
  userConsent,
  debugGTMID = "PVVJVR5",
  customeProxy,
  cloudFront = true,
  initMedium = {},
  devMode = false,
  compatibilities = {
    GA3: true,
    GA4: false
  },
  children
}) => {
  const { GA3, GA4 } = compatibilities;
  const load = () => {
    if (typeof window === "undefined") return;
    if (GA3) GTMLoad_default(window, document, "script", "dataLayer", `GTM-${debugGTMID}`, cloudFront, customeProxy);
    if (GA4) GTMLoad_default(window, document, "script", "dataLayer", `GTM-5THNWXP`, false, void 0, true);
  };
  const init = () => {
    if (typeof window === "undefined") return;
    userConsent === true && window.thor.onConsent();
  };
  useEffect(init, [userConsent]);
  useEffect(load, []);
  return /* @__PURE__ */ React2.createElement(
    StateProvider,
    {
      reducer,
      initialState: { ...initialState, medium: initMedium, devMode, compatibilities }
    },
    children
  );
};

// src/components/withThorTestWrapper.tsx
import React3 from "react";
import "thor";
var WithThorTestWrapper = ({
  children,
  initMedium = {}
}) => {
  return /* @__PURE__ */ React3.createElement(StateProvider, { reducer, initialState: { ...initialState, medium: initMedium, devMode: false } }, children);
};

// src/components/thorView.tsx
import React4, { useEffect as useEffect2 } from "react";

// src/helpers/isObject.ts
var isObject = (o) => Object.prototype.toString.call(o) === "[object Object]";

// src/helpers/buildProducts.ts
var buildProducts = (products) => {
  const _products = Array.isArray(products) ? products.filter((product) => isObject(product) && !!product.id) : null;
  return _products?.length ? _products : void 0;
};

// src/helpers/buildItems.ts
var buildItems = (items) => {
  const _items = Array.isArray(items) ? items.filter((item) => isObject(item) && !!item.id) : null;
  return _items?.length ? _items : void 0;
};

// src/helpers/isFlagged.ts
var isFlagged = (flag, flags) => {
  if (typeof flag !== "string" || !!!flag) return null;
  return flags?.flagged?.[flag] === true;
};

// src/helpers/encryptEmail.ts
import md5 from "crypto-js/md5.js";
import sha256 from "crypto-js/sha256.js";
var encryptEmail = (email = "") => {
  if (typeof email !== "string" || !!!email) return;
  const encryptedEmailLegacy = md5(email.toLowerCase()).toString();
  const encryptedEmail = sha256(email.toLowerCase()).toString();
  return { md5: encryptedEmailLegacy, sha256: encryptedEmail };
};

// src/helpers/flagReg.ts
var reg = /#\{([^}]+)\}/;
var flagReg_default = reg;

// src/helpers/getInfos.ts
var getInfos = ({ infos }, flags) => {
  if (flagReg_default.test(infos) && flags.savedInfos?.hasOwnProperty(infos.match(flagReg_default)[1]))
    return flags.savedInfos[infos.match(flagReg_default)[1]];
  else return infos;
};

// src/helpers/dataLayerReset.ts
var reset = () => {
  window.dataLayer.push(function() {
    this.reset();
  });
  window.thor.dataLayer = {};
};
var didomiConsents = () => {
  if (!!!window.Didomi) return;
  const didomiPurposesConsent = window.Didomi.getUserStatus().purposes.consent.enabled.join(",");
  !!didomiPurposesConsent && window.thor.pushVariable({ didomiPurposesConsent });
};
var userCentricsConsents = () => {
  if (!!!window.UC_UI) return;
  const USCEPurposesConsent = window.UC_UI.getServicesBaseInfo();
  let status = { action: "onSpaView", event: "consent_status" };
  USCEPurposesConsent.forEach((purpose) => {
    status[purpose.name] = purpose.consent.status;
  });
  !!status && window.thor.pushVariable(status);
};
var dataLayerReset = () => {
  reset();
  didomiConsents();
  userCentricsConsents();
};

// src/helpers/containerMapping.ts
var mapperGA4View = (viewProps) => {
  const data = viewProps;
  data.av_pagetitle = viewProps.av_pagetitle || viewProps.pagename;
  delete data.pagename;
  data.av_site = viewProps.av_site || viewProps.site;
  delete data.site;
  data.av_environment = viewProps.av_environment || viewProps.environment;
  delete data.environment;
  data.av_language = viewProps.av_language || viewProps.language;
  delete data.language;
  if (!!viewProps.av_items) data.av_items = buildItems(viewProps.av_items);
  if (!!viewProps.av_search) data.av_search = viewProps.av_search;
  if (!!viewProps.email_account) {
    const encrypt = encryptEmail(viewProps.email_account);
    data.email_account_md5 = encrypt.md5;
    data.email_account = encrypt.sha256;
  }
  return data;
};
var mapperGA3View = (viewProps) => {
  const data = viewProps;
  if (!!viewProps.products) data.products = buildProducts(viewProps.products);
  if (!!viewProps.search) data.search = viewProps.search;
  if (!!viewProps.email_account) {
    const encrypt = encryptEmail(viewProps.email_account);
    data.email_account_md5 = encrypt.md5;
    data.email_account = encrypt.sha256;
  }
  return data;
};
var mapperGA4Event = (data, additionalProps) => {
  const updatedData = {
    ...data,
    ...additionalProps
  };
  const items = buildItems(data?.av_items);
  if (items?.length) updatedData.av_items = items;
  if (!!data?.email_lead) {
    const encrypt = encryptEmail(data?.email_lead);
    updatedData.email_lead_md5 = encrypt.md5;
    updatedData.email_lead = encrypt.sha256;
  }
  return updatedData;
};
var mapperGA3Event = (data, additionalProps, flags) => {
  const updatedData = {
    int_type: data?.type,
    int_description: data?.description,
    form_profile: data?.form_profile,
    int_infos: getInfos(data, flags),
    ...additionalProps
  };
  const products = buildProducts(data?.products);
  if (products?.length) updatedData.products = products;
  if (typeof data.nievent !== "undefined") updatedData.nievent = data.nievent;
  if (!!data?.email_lead) {
    const encrypt = encryptEmail(data?.email_lead);
    updatedData.email_lead_md5 = encrypt.md5;
    updatedData.email_lead = encrypt.sha256;
  }
  return updatedData;
};
var getData = (gaVersion, eventData, additionalProps, flags) => {
  if (gaVersion === "GA3") {
    return {
      event: "interaction",
      data: mapperGA3Event(eventData, additionalProps, flags)
    };
  } else if (gaVersion === "GA4") {
    const event = eventData.event;
    delete eventData.event;
    const data = mapperGA4Event(eventData, additionalProps);
    return { event, data };
  }
};
var handleEvent = (gaVersion, viewProps, additionalProps, resetDataLayer, dataLayerReset2, devMode) => {
  let event = "";
  let data = {
    ...viewProps,
    ...additionalProps
  };
  if (gaVersion === "GA3") {
    event = "view";
  } else if (gaVersion === "GA4") {
    event = "page_view";
  }
  triggerViews(event, data, gaVersion, resetDataLayer, dataLayerReset2, devMode);
};
var triggerViews = (event, data, gaVersion, resetDataLayer, dataLayerReset2, devMode) => {
  let _data = data;
  if (gaVersion === "GA3") {
    _data = mapperGA3View(data);
  } else if (gaVersion === "GA4") {
    _data = mapperGA4View(data);
  }
  try {
    resetDataLayer && dataLayerReset2();
    window.thor.pushEvent(event, _data);
    if (devMode) console.log("pushEvent", event, _data);
  } catch (e) {
    console.warn(e);
  }
};

// src/components/thorView.tsx
var ThorView = ({
  updateOn = [],
  viewProps,
  additionalProps = {},
  resetDataLayer = true,
  compatibilities = null
}) => {
  const [{ devMode, compatibilities: appCompatibilities }] = useStateValue();
  const _compatibilities = compatibilities || appCompatibilities;
  useEffect2(() => {
    let shouldReset = resetDataLayer;
    for (const gaVersion in _compatibilities) {
      if (_compatibilities[gaVersion]) {
        handleEvent(gaVersion, viewProps, additionalProps, resetDataLayer, dataLayerReset, devMode);
        shouldReset = false;
      }
    }
  }, [...updateOn]);
  return /* @__PURE__ */ React4.createElement(React4.Fragment, null);
};

// src/components/thorEvent.tsx
import React5, { useState, useEffect as useEffect3 } from "react";
var ThorEvent = ({
  htmlTag = "div",
  eventData,
  unique,
  flag,
  onClick,
  onDisplay,
  id,
  className,
  saveInfos,
  children,
  testId,
  additionalProps = {},
  compatibilities = null,
  ...props
}) => {
  const [triggered, setTrigger] = useState(false);
  const [{ devMode, flags, compatibilities: appCompatibilities }, dispatch] = useStateValue();
  const Tag = htmlTag ? htmlTag : "div";
  const _compatibilities = compatibilities || appCompatibilities;
  const hasFlag = typeof window !== "undefined" && typeof flag === "string" && !!flag;
  const saveInfosDatas = (key, value) => dispatch({
    type: "UPDATE_SAVED_INFO",
    payload: {
      key,
      value
    }
  });
  const triggerEvent = () => {
    for (const gaVersion in _compatibilities) {
      if (_compatibilities[gaVersion]) {
        if (triggered || hasFlag && isFlagged(flag, flags)) return;
        const { data, event } = getData(gaVersion, eventData, additionalProps, flags);
        try {
          window.thor.pushEvent(event, data);
          if (devMode) console.log("pushEvent", event, data);
          gaVersion === "GA3" && saveInfosDatas(saveInfos, eventData?.infos);
          if (unique === true) setTrigger(true);
          hasFlag && dispatch({
            type: "ADD_FLAGGED",
            payload: flag
          });
        } catch (e) {
          console.warn(e);
        }
      }
    }
  };
  const handleClick = (event) => {
    if (typeof onClick === "function")
      onClick(event, { htmlTag, eventData, unique, flag, onDisplay, id, className, saveInfos, ...props });
    if (onDisplay !== true) triggerEvent();
  };
  useEffect3(() => {
    if (onDisplay === true) triggerEvent();
  }, []);
  return /* @__PURE__ */ React5.createElement(Tag, { id: id || null, className: className || null, onClick: handleClick, "data-testid": !!testId ? testId : null }, children);
};

// src/components/thorData.tsx
import React6, { useState as useState2, useEffect as useEffect4 } from "react";
var ThorData = ({
  updateOn = [],
  htmlTag = "div",
  data,
  unique,
  flag,
  onClick,
  onDisplay,
  id,
  className,
  children,
  testId,
  ...props
}) => {
  const [triggered, setTrigger] = useState2(false);
  const [{ devMode, flags }, dispatch] = useStateValue();
  const Tag = htmlTag ? htmlTag : "div";
  const hasFlag = typeof window !== "undefined" && typeof flag === "string" && !!flag;
  const triggerEvent = () => {
    if (triggered || hasFlag && isFlagged(flag, flags)) return;
    const _data = data;
    const items = buildItems(data?.av_items);
    if (items?.length) _data.av_items = items;
    if (!!data?.email_lead) _data.email_lead = encryptEmail(_data?.email_lead);
    try {
      window.thor.pushVariable(_data);
      if (devMode) console.log("pushVariable", _data);
      if (unique === true) setTrigger(true);
      hasFlag && dispatch({
        type: "ADD_FLAGGED",
        payload: flag
      });
    } catch (e) {
      console.warn(e);
    }
  };
  const handleClick = (event) => {
    if (typeof onClick === "function")
      onClick(event, { htmlTag, data, unique, flag, onDisplay, id, className, ...props });
    if (onDisplay !== true) triggerEvent();
  };
  useEffect4(() => {
    if (onDisplay === true || htmlTag === "div") triggerEvent();
  }, [...updateOn]);
  return /* @__PURE__ */ React6.createElement(Tag, { id: id || null, className: className || null, onClick: handleClick, "data-testid": !!testId ? testId : null }, children);
};

// src/hooks/useThorEvent.ts
import { useState as useState3 } from "react";
var useThorEvent = ({
  unique,
  flag,
  saveInfos,
  eventData,
  additionalProps = {},
  compatibilities = null
}) => {
  const [triggered, setTrigger] = useState3(false);
  const [{ devMode, flags, compatibilities: appCompatibilities }, dispatch] = useStateValue();
  const saveInfosDatas = (key, value) => dispatch({
    type: "UPDATE_SAVED_INFO",
    payload: {
      key,
      value
    }
  });
  const trigger = ({
    eventData: _eventData = {},
    additionalProps: _additionalProps = {},
    compatibilities: _compatibilities = compatibilities || appCompatibilities
  } = {}) => {
    const mergedEventData = { ...eventData, ..._eventData };
    const mergedAdditionalProps = { ...additionalProps, ..._additionalProps };
    const hasFlag = typeof window !== "undefined" && typeof flag === "string" && !!flag;
    if (triggered || hasFlag && isFlagged(flag, flags)) return;
    for (const gaVersion in _compatibilities) {
      if (_compatibilities[gaVersion]) {
        const { data, event } = getData(gaVersion, mergedEventData, mergedAdditionalProps, flags);
        try {
          window.thor.pushEvent(event, data);
          if (devMode) console.log("pushEvent", event, data);
          gaVersion === "GA3" && saveInfosDatas(saveInfos, mergedEventData.infos);
          if (unique === true) setTrigger(true);
          hasFlag && dispatch({
            type: "ADD_FLAGGED",
            payload: flag
          });
        } catch (e) {
          console.warn(e);
        }
      }
    }
  };
  return trigger;
};

// src/hooks/useThorView.ts
var useThorView = ({
  viewProps = {},
  additionalProps = {},
  resetDataLayer = true,
  compatibilities = null
} = {}) => {
  const [{ devMode, compatibilities: appCompatibilities }] = useStateValue();
  const view = ({
    viewProps: _viewProps = {},
    additionalProps: _additionalProps = {},
    resetDataLayer: _resetDataLayer = resetDataLayer,
    compatibilities: _compatibilities = compatibilities || appCompatibilities
  } = {}) => {
    let shouldReset = _resetDataLayer;
    for (const gaVersion in _compatibilities) {
      if (_compatibilities[gaVersion]) {
        const mergedViewsProps = { ...viewProps, ..._viewProps };
        const mergedAdditionalProps = { ...additionalProps, ..._additionalProps };
        handleEvent(gaVersion, mergedViewsProps, mergedAdditionalProps, shouldReset, dataLayerReset, devMode);
        shouldReset = false;
      }
    }
  };
  return view;
};

// src/hooks/useThorData.ts
import { useState as useState4 } from "react";
var useThorData = ({
  unique,
  flag,
  saveInfos,
  data
}) => {
  const [triggered, setTrigger] = useState4(false);
  const [{ devMode, flags }, dispatch] = useStateValue();
  const trigger = ({
    data: _data = {}
  } = {}) => {
    const mergedData = { ...data, ..._data };
    const hasFlag = typeof window !== "undefined" && typeof flag === "string" && !!flag;
    if (triggered || hasFlag && isFlagged(flag, flags)) return;
    const items = buildItems(data?.av_items);
    if (items?.length) mergedData.av_items = items;
    if (!!data?.email_lead) mergedData.email_lead = encryptEmail(data?.email_lead);
    window.thor.pushVariable(mergedData);
    if (devMode) console.log("pushVariable", mergedData);
    if (unique === true) setTrigger(true);
    hasFlag && dispatch({
      type: "ADD_FLAGGED",
      payload: flag
    });
  };
  return trigger;
};

// src/hooks/useSaveMedium.ts
var useSaveMedium = (key, value) => {
  const [{ medium: savedMedium }, dispatch] = useStateValue();
  const medium = savedMedium?.[key];
  const saveMedium = (newValue = value) => {
    dispatch({
      type: "UPDATE_MEDIUM",
      payload: {
        key,
        value: newValue
      }
    });
  };
  return [medium, saveMedium];
};
export {
  ThorData,
  ThorEvent,
  ThorView,
  WithThor,
  WithThorTestWrapper,
  useSaveMedium,
  useThorData,
  useThorEvent,
  useThorView
};
